module.exports = __webpack_public_path__ + "static/media/logo-dreamtv@3x.4bff8f06.png";